import { FORM_LANGUAGES, type FormLanguage } from '@chat-emp/shared';

import { LANGUAGE_LABEL } from '../data/forms.js';
import styles from './LanguageSwitch.module.css';

/** Which language the catalogue is read in. A view, not a filter that multiplies
 * cards: the same fifty templates, in the words the jobseeker will read. */
export function LanguageSwitch({
  value,
  onChange,
}: {
  value: FormLanguage;
  onChange: (language: FormLanguage) => void;
}) {
  return (
    <div className={styles.switch} role="group" aria-label="Template language">
      {FORM_LANGUAGES.map((language) => (
        <button
          key={language}
          type="button"
          className={language === value ? styles.optionOn : styles.option}
          aria-pressed={language === value}
          title={LANGUAGE_LABEL[language].name}
          onClick={() => onChange(language)}
        >
          {LANGUAGE_LABEL[language].short}
        </button>
      ))}
    </div>
  );
}
